<script setup lang="ts">
import type { InputHTMLAttributes } from "vue";

defineProps<
  Omit</* @vue-ignore */ InputHTMLAttributes, "type" | "value" | "onInput"> & {
    modelValue: number | null;
  }
>();

const emit = defineEmits<{ "update:modelValue": [value: number | null] }>();

function onInput(event: Event) {
  const value = (event.target as HTMLInputElement).valueAsNumber;

  if (Number.isNaN(value)) {
    emit("update:modelValue", null);
  } else {
    emit("update:modelValue", value);
  }
}
</script>

<template>
  <input v-bind="$attrs" type="number" :value="modelValue" @input="onInput" />
</template>
